'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _CloseFilled = require('./lib/icons/CloseFilled');
  
  
  var _default = _CloseFilled;
  exports.default = _default;
  module.exports = _default;